// Données mockées pour la Base de Connaissances et Documentation

export type DocumentCategory = 'guidelines' | 'templates' | 'procedures' | 'pricing' | 'other';
export type DocumentStatus = 'draft' | 'approved' | 'archived';
export type DocumentAccess = 'all' | 'agence' | 'soebra' | 'admin';

export interface DocumentVersion {
  id: string;
  version: string;
  file_name: string;
  file_size: number;
  file_type: string;
  file_url: string;
  uploaded_by: string;
  uploaded_by_name: string;
  uploaded_at: string;
  is_current: boolean;
  change_log?: string;
}

export interface Document {
  id: string;
  title: string;
  description?: string;
  category: DocumentCategory;
  folder?: string;
  status: DocumentStatus;
  access_level: DocumentAccess;
  versions: DocumentVersion[];
  current_version: DocumentVersion;
  tags: string[];
  created_by: string;
  created_by_name: string;
  created_at: string;
  updated_at: string;
  approved_by?: string;
  approved_by_name?: string;
  approved_at?: string;
  download_count: number;
  last_downloaded_at?: string;
}

export const mockDocuments: Document[] = [
  {
    id: 'doc-001',
    title: 'Guidelines de Marque SOBEBRA 2024',
    description: 'Document de référence complet pour l\'utilisation de la marque SOBEBRA, incluant logos, couleurs, typographie et règles d\'utilisation',
    category: 'guidelines',
    folder: 'Brand Guidelines',
    status: 'approved',
    access_level: 'all',
    versions: [
      {
        id: 'v-001-3',
        version: '3.0',
        file_name: 'SOBEBRA_Brand_Guidelines_2024_v3.0.pdf',
        file_size: 5242880,
        file_type: 'application/pdf',
        file_url: '/documents/guidelines/SOBEBRA_Brand_Guidelines_2024_v3.0.pdf',
        uploaded_by: 'soebra-001',
        uploaded_by_name: 'SOBEBRA - Direction Marketing',
        uploaded_at: '2024-11-01T10:00:00Z',
        is_current: true,
        change_log: 'Mise à jour des logos et ajout des nouvelles couleurs de marque',
      },
      {
        id: 'v-001-2',
        version: '2.0',
        file_name: 'SOBEBRA_Brand_Guidelines_2024_v2.0.pdf',
        file_size: 4980000,
        file_type: 'application/pdf',
        file_url: '/documents/guidelines/SOBEBRA_Brand_Guidelines_2024_v2.0.pdf',
        uploaded_by: 'soebra-001',
        uploaded_by_name: 'SOBEBRA - Direction Marketing',
        uploaded_at: '2024-06-15T10:00:00Z',
        is_current: false,
        change_log: 'Corrections mineures',
      },
    ],
    current_version: {
      id: 'v-001-3',
      version: '3.0',
      file_name: 'SOBEBRA_Brand_Guidelines_2024_v3.0.pdf',
      file_size: 5242880,
      file_type: 'application/pdf',
      file_url: '/documents/guidelines/SOBEBRA_Brand_Guidelines_2024_v3.0.pdf',
      uploaded_by: 'soebra-001',
      uploaded_by_name: 'SOBEBRA - Direction Marketing',
      uploaded_at: '2024-11-01T10:00:00Z',
      is_current: true,
      change_log: 'Mise à jour des logos et ajout des nouvelles couleurs de marque',
    },
    tags: ['marque', 'logo', 'identité visuelle', 'SOBEBRA'],
    created_by: 'soebra-001',
    created_by_name: 'SOBEBRA - Direction Marketing',
    created_at: '2024-01-15T10:00:00Z',
    updated_at: '2024-11-01T10:00:00Z',
    approved_by: 'soebra-001',
    approved_by_name: 'SOBEBRA - Direction Marketing',
    approved_at: '2024-11-01T10:30:00Z',
    download_count: 45,
    last_downloaded_at: '2024-11-14T15:30:00Z',
  },
  {
    id: 'doc-002',
    title: 'Modèle de Rapport d\'Activation Standard',
    description: 'Template standardisé pour les rapports d\'activation terrain avec sections obligatoires et format de présentation',
    category: 'templates',
    folder: 'Modèles de Rapports',
    status: 'approved',
    access_level: 'agence',
    versions: [
      {
        id: 'v-002-2',
        version: '2.0',
        file_name: 'Modele_Rapport_Activation_v2.0.docx',
        file_size: 256000,
        file_type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        file_url: '/documents/templates/Modele_Rapport_Activation_v2.0.docx',
        uploaded_by: 'agence-001',
        uploaded_by_name: 'Agence Zenith Productions',
        uploaded_at: '2024-10-15T09:00:00Z',
        is_current: true,
        change_log: 'Ajout de la section géolocalisation et photos',
      },
    ],
    current_version: {
      id: 'v-002-2',
      version: '2.0',
      file_name: 'Modele_Rapport_Activation_v2.0.docx',
      file_size: 256000,
      file_type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      file_url: '/documents/templates/Modele_Rapport_Activation_v2.0.docx',
      uploaded_by: 'agence-001',
      uploaded_by_name: 'Agence Zenith Productions',
      uploaded_at: '2024-10-15T09:00:00Z',
      is_current: true,
      change_log: 'Ajout de la section géolocalisation et photos',
    },
    tags: ['rapport', 'template', 'activation', 'modèle'],
    created_by: 'agence-001',
    created_by_name: 'Agence Zenith Productions',
    created_at: '2024-03-01T10:00:00Z',
    updated_at: '2024-10-15T09:00:00Z',
    approved_by: 'soebra-001',
    approved_by_name: 'SOBEBRA - Direction Marketing',
    approved_at: '2024-10-16T10:00:00Z',
    download_count: 128,
    last_downloaded_at: '2024-11-15T10:00:00Z',
  },
  {
    id: 'doc-003',
    title: 'Procédures d\'Activation BTL - Guide Complet',
    description: 'Guide détaillé des procédures à suivre pour les activations BTL, de la planification à l\'évaluation post-activation',
    category: 'procedures',
    folder: 'Procédures',
    status: 'approved',
    access_level: 'all',
    versions: [
      {
        id: 'v-003-1',
        version: '1.0',
        file_name: 'Procedures_Activation_BTL_2024.pdf',
        file_size: 3145728,
        file_type: 'application/pdf',
        file_url: '/documents/procedures/Procedures_Activation_BTL_2024.pdf',
        uploaded_by: 'agence-001',
        uploaded_by_name: 'Agence Zenith Productions',
        uploaded_at: '2024-09-01T10:00:00Z',
        is_current: true,
        change_log: 'Version initiale',
      },
    ],
    current_version: {
      id: 'v-003-1',
      version: '1.0',
      file_name: 'Procedures_Activation_BTL_2024.pdf',
      file_size: 3145728,
      file_type: 'application/pdf',
      file_url: '/documents/procedures/Procedures_Activation_BTL_2024.pdf',
      uploaded_by: 'agence-001',
      uploaded_by_name: 'Agence Zenith Productions',
      uploaded_at: '2024-09-01T10:00:00Z',
      is_current: true,
      change_log: 'Version initiale',
    },
    tags: ['procédures', 'BTL', 'activation', 'guide'],
    created_by: 'agence-001',
    created_by_name: 'Agence Zenith Productions',
    created_at: '2024-09-01T10:00:00Z',
    updated_at: '2024-09-01T10:00:00Z',
    approved_by: 'soebra-001',
    approved_by_name: 'SOBEBRA - Direction Marketing',
    approved_at: '2024-09-05T10:00:00Z',
    download_count: 89,
    last_downloaded_at: '2024-11-13T14:20:00Z',
  },
  {
    id: 'doc-004',
    title: 'Tarifs Produits SOBEBRA 2024',
    description: 'Grille tarifaire complète des produits SOBEBRA pour les activations et promotions',
    category: 'pricing',
    folder: 'Tarifs',
    status: 'approved',
    access_level: 'agence',
    versions: [
      {
        id: 'v-004-4',
        version: '4.0',
        file_name: 'Tarifs_SOBEBRA_2024_Q4_v4.0.xlsx',
        file_size: 128000,
        file_type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        file_url: '/documents/pricing/Tarifs_SOBEBRA_2024_Q4_v4.0.xlsx',
        uploaded_by: 'soebra-001',
        uploaded_by_name: 'SOBEBRA - Direction Marketing',
        uploaded_at: '2024-10-01T10:00:00Z',
        is_current: true,
        change_log: 'Mise à jour Q4 2024 avec nouveaux produits',
      },
      {
        id: 'v-004-3',
        version: '3.0',
        file_name: 'Tarifs_SOBEBRA_2024_Q3_v3.0.xlsx',
        file_size: 125000,
        file_type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        file_url: '/documents/pricing/Tarifs_SOBEBRA_2024_Q3_v3.0.xlsx',
        uploaded_by: 'soebra-001',
        uploaded_by_name: 'SOBEBRA - Direction Marketing',
        uploaded_at: '2024-07-01T10:00:00Z',
        is_current: false,
        change_log: 'Mise à jour Q3 2024',
      },
    ],
    current_version: {
      id: 'v-004-4',
      version: '4.0',
      file_name: 'Tarifs_SOBEBRA_2024_Q4_v4.0.xlsx',
      file_size: 128000,
      file_type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      file_url: '/documents/pricing/Tarifs_SOBEBRA_2024_Q4_v4.0.xlsx',
      uploaded_by: 'soebra-001',
      uploaded_by_name: 'SOBEBRA - Direction Marketing',
      uploaded_at: '2024-10-01T10:00:00Z',
      is_current: true,
      change_log: 'Mise à jour Q4 2024 avec nouveaux produits',
    },
    tags: ['tarifs', 'prix', 'produits', '2024'],
    created_by: 'soebra-001',
    created_by_name: 'SOBEBRA - Direction Marketing',
    created_at: '2024-01-01T10:00:00Z',
    updated_at: '2024-10-01T10:00:00Z',
    approved_by: 'soebra-001',
    approved_by_name: 'SOBEBRA - Direction Marketing',
    approved_at: '2024-10-01T11:00:00Z',
    download_count: 67,
    last_downloaded_at: '2024-11-12T09:15:00Z',
  },
  {
    id: 'doc-005',
    title: 'Guide d\'Utilisation des Logos SOBEBRA',
    description: 'Guide visuel pour l\'utilisation correcte des logos SOBEBRA dans les supports promotionnels',
    category: 'guidelines',
    folder: 'Brand Guidelines',
    status: 'approved',
    access_level: 'all',
    versions: [
      {
        id: 'v-005-2',
        version: '2.0',
        file_name: 'Guide_Logos_SOBEBRA_v2.0.pdf',
        file_size: 2097152,
        file_type: 'application/pdf',
        file_url: '/documents/guidelines/Guide_Logos_SOBEBRA_v2.0.pdf',
        uploaded_by: 'soebra-001',
        uploaded_by_name: 'SOBEBRA - Direction Marketing',
        uploaded_at: '2024-11-01T10:00:00Z',
        is_current: true,
        change_log: 'Ajout des nouveaux formats de logos',
      },
    ],
    current_version: {
      id: 'v-005-2',
      version: '2.0',
      file_name: 'Guide_Logos_SOBEBRA_v2.0.pdf',
      file_size: 2097152,
      file_type: 'application/pdf',
      file_url: '/documents/guidelines/Guide_Logos_SOBEBRA_v2.0.pdf',
      uploaded_by: 'soebra-001',
      uploaded_by_name: 'SOBEBRA - Direction Marketing',
      uploaded_at: '2024-11-01T10:00:00Z',
      is_current: true,
      change_log: 'Ajout des nouveaux formats de logos',
    },
    tags: ['logo', 'marque', 'identité visuelle'],
    created_by: 'soebra-001',
    created_by_name: 'SOBEBRA - Direction Marketing',
    created_at: '2024-05-01T10:00:00Z',
    updated_at: '2024-11-01T10:00:00Z',
    approved_by: 'soebra-001',
    approved_by_name: 'SOBEBRA - Direction Marketing',
    approved_at: '2024-11-01T10:30:00Z',
    download_count: 112,
    last_downloaded_at: '2024-11-14T16:00:00Z',
  },
  {
    id: 'doc-006',
    title: 'Modèle de Brief d\'Activation',
    description: 'Template pour créer un brief d\'activation complet avec objectifs, cibles et KPIs',
    category: 'templates',
    folder: 'Modèles de Rapports',
    status: 'approved',
    access_level: 'agence',
    versions: [
      {
        id: 'v-006-1',
        version: '1.0',
        file_name: 'Modele_Brief_Activation_v1.0.docx',
        file_size: 128000,
        file_type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        file_url: '/documents/templates/Modele_Brief_Activation_v1.0.docx',
        uploaded_by: 'agence-001',
        uploaded_by_name: 'Agence Zenith Productions',
        uploaded_at: '2024-08-01T10:00:00Z',
        is_current: true,
        change_log: 'Version initiale',
      },
    ],
    current_version: {
      id: 'v-006-1',
      version: '1.0',
      file_name: 'Modele_Brief_Activation_v1.0.docx',
      file_size: 128000,
      file_type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      file_url: '/documents/templates/Modele_Brief_Activation_v1.0.docx',
      uploaded_by: 'agence-001',
      uploaded_by_name: 'Agence Zenith Productions',
      uploaded_at: '2024-08-01T10:00:00Z',
      is_current: true,
      change_log: 'Version initiale',
    },
    tags: ['brief', 'template', 'activation'],
    created_by: 'agence-001',
    created_by_name: 'Agence Zenith Productions',
    created_at: '2024-08-01T10:00:00Z',
    updated_at: '2024-08-01T10:00:00Z',
    approved_by: 'soebra-001',
    approved_by_name: 'SOBEBRA - Direction Marketing',
    approved_at: '2024-08-05T10:00:00Z',
    download_count: 34,
    last_downloaded_at: '2024-11-10T11:00:00Z',
  },
  {
    id: 'doc-007',
    title: 'Vidéo : Formation Activation Terrain',
    description: 'Vidéo de formation pour les agents terrain sur les bonnes pratiques d\'activation',
    category: 'procedures',
    folder: 'Formations',
    status: 'approved',
    access_level: 'all',
    versions: [
      {
        id: 'v-007-1',
        version: '1.0',
        file_name: 'Formation_Activation_Terrain_2024.mp4',
        file_size: 52428800,
        file_type: 'video/mp4',
        file_url: '/documents/procedures/Formation_Activation_Terrain_2024.mp4',
        uploaded_by: 'agence-001',
        uploaded_by_name: 'Agence Zenith Productions',
        uploaded_at: '2024-09-15T10:00:00Z',
        is_current: true,
        change_log: 'Version initiale',
      },
    ],
    current_version: {
      id: 'v-007-1',
      version: '1.0',
      file_name: 'Formation_Activation_Terrain_2024.mp4',
      file_size: 52428800,
      file_type: 'video/mp4',
      file_url: '/documents/procedures/Formation_Activation_Terrain_2024.mp4',
      uploaded_by: 'agence-001',
      uploaded_by_name: 'Agence Zenith Productions',
      uploaded_at: '2024-09-15T10:00:00Z',
      is_current: true,
      change_log: 'Version initiale',
    },
    tags: ['formation', 'vidéo', 'terrain', 'activation'],
    created_by: 'agence-001',
    created_by_name: 'Agence Zenith Productions',
    created_at: '2024-09-15T10:00:00Z',
    updated_at: '2024-09-15T10:00:00Z',
    approved_by: 'soebra-001',
    approved_by_name: 'SOBEBRA - Direction Marketing',
    approved_at: '2024-09-20T10:00:00Z',
    download_count: 56,
    last_downloaded_at: '2024-11-11T13:00:00Z',
  },
];

export const getCategoryLabel = (category: DocumentCategory): string => {
  switch (category) {
    case 'guidelines':
      return 'Guidelines de Marque';
    case 'templates':
      return 'Modèles';
    case 'procedures':
      return 'Procédures';
    case 'pricing':
      return 'Tarifs';
    case 'other':
      return 'Autre';
    default:
      return category;
  }
};

export const getStatusLabel = (status: DocumentStatus | string): string => {
  // Traduire les statuts anglais en français
  if (status === 'pending') return 'En attente';
  if (status === 'approved') return 'Approuvé';
  if (status === 'rejected') return 'Rejeté';
  
  switch (status) {
    case 'draft':
      return 'Brouillon';
    case 'approved':
      return 'Approuvé';
    case 'archived':
      return 'Archivé';
    default:
      return status;
  }
};

export const getAccessLabel = (access: DocumentAccess): string => {
  switch (access) {
    case 'all':
      return 'Tous';
    case 'agence':
      return 'Agence uniquement';
    case 'soebra':
      return 'SOBEBRA uniquement';
    case 'admin':
      return 'Administrateur uniquement';
    default:
      return access;
  }
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
};

export const getFileIcon = (fileType: string): string => {
  if (fileType.includes('pdf')) return '📄';
  if (fileType.includes('word') || fileType.includes('document')) return '📝';
  if (fileType.includes('excel') || fileType.includes('spreadsheet')) return '📊';
  if (fileType.includes('image')) return '🖼️';
  if (fileType.includes('video')) return '🎥';
  return '📎';
};





